export enum DateTimeFormats {
  ddMMYYYY_SLASH = 'dd/MM/YYYY',
  DDMMYY_SLASH = 'DD/MM/YY',
  MMYYYY_SLASH = 'MM/YYYY',
  DDMMMMYYYY_SPACE = 'DD MMMM YYYY',
  MMMMYYYY_SPACE = 'MMMM YYYY',
  NTH_OF_MONTH = 'Do MMMM',
}
